export const TurnOrderTypes = {
    OPEN_TURNORDER : 'OPEN_TURNORDER_TURNORDER',
    CLOSE_TURNORDER : 'CLOSE_TURNORDER_TURNORDER',
    TOGGLE_TURNORDER : 'TOGGLE_TURNORDER_TURNORDER',
    SET_TURNORDER : 'SET_TURNORDER_TURNORDER',
    SET_TURNS : 'SET_TURNS_TURNORDER',
    ADD_TURNORDER : 'ADD_TURNORDER_TURNORDER',
    REMOVE_TURNORDER : 'REMOVE_TURNORDER_TURNORDER',
    EDIT_TURNORDER : 'EDIT_TURNORDER_TURNORDER',
    RESET : 'RESET',
};